import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { HelmetProvider, Helmet } from "react-helmet-async";
import { LanguageProvider } from "./context/LanguageContext";
import "@/App.css";
import Header from "./components/Header";
import Hero from "./components/Hero";
import WelcomeSection from "./components/WelcomeSection";
import CommunityPhotos from "./components/CommunityPhotos";
import About from "./components/About";
import VisitUs from "./components/VisitUs";
import LiveStream from "./components/LiveStream";
import DailyVerse from "./components/DailyVerse";
import Sermons from "./components/Sermons";
import Events from "./components/Events";
import YouthArise from "./components/YouthArise";
import InstagramFeed from "./components/InstagramFeed";
import GallerySection from "./components/GallerySection";
import VisitorRegistration from "./components/VisitorRegistration";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import MobileBottomNav from "./components/MobileBottomNav";
import ChatWidget from "./components/ChatWidget";
import CookieBanner from "./components/CookieBanner";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import Datenschutz from "./pages/Datenschutz";
import Impressum from "./pages/Impressum";
import AGB from "./pages/AGB";
import MemberAuth from "./pages/MemberAuth";
import MemberDashboard from "./pages/MemberDashboard";

function HomePage() {
  return (
    <>
      <Helmet>
        <title>Internationale Christengemeinde Hannover | ICG Hannover</title>
        <meta name="description" content="Willkommen bei der Internationalen Christengemeinde Hannover. Gottesdienste, Predigten, Live-Stream, Gebetsabende und eine lebendige Gemeinschaft am Klagesmarkt 29, Hannover." />
        <link rel="canonical" href="https://www.icg-hannover.de/" />
      </Helmet>
      <Header />
      <main className="pb-16 lg:pb-0">
        <Hero />
        <WelcomeSection />
        <CommunityPhotos />
        <About />
        <Events />
        <VisitUs />
        <YouthArise />
        <DailyVerse />
        <Sermons />
        <GallerySection />
        <VisitorRegistration />
        <InstagramFeed />
        <Contact />
      </main>
      <Footer />
      <MobileBottomNav />
      <ChatWidget />
    </>
  );
}

const API_URL = process.env.REACT_APP_BACKEND_URL;

function PageTracker() {
  const location = useLocation();
  useEffect(() => {
    fetch(`${API_URL}/api/analytics/track`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ page: location.pathname, referrer: document.referrer })
    }).catch(() => {});
  }, [location.pathname]);
  return null;
}

function App() {
  return (
    <HelmetProvider>
      <LanguageProvider>
        <BrowserRouter>
          <PageTracker />
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin/dashboard" element={<AdminDashboard />} />
            <Route path="/datenschutz" element={<Datenschutz />} />
            <Route path="/impressum" element={<Impressum />} />
            <Route path="/agb" element={<AGB />} />
            <Route path="/mitglieder/login" element={<MemberAuth />} />
            <Route path="/mitglieder" element={<MemberDashboard />} />
          </Routes>
          <CookieBanner />
        </BrowserRouter>
      </LanguageProvider>
    </HelmetProvider>
  );
}

export default App;
